import PortfolioShow from "../../../components/sections/portfolioShow";
import Head from "next/head"

export default function Corporativo() {
  return (
    <>
      <Head>
        <title>Sara Fontoura - Fotografia Corporativa</title>
        <meta
          property="og:title"
          content="Sara Fontoura - Fotografia Corporativa"
          key="title"
        />
        <meta
          property="og:description"
          content="Fotografia Corporativa"
          key="ogdesc"
        />
      </Head>
      <PortfolioShow
        title="Fotografia Corporativa"
        subTitle={false}
        folderPath="fotos/corporativa/corporativo"
        mainPhotoUrl="/fotos/corporativa/corporativo/DSC00852.webp"
        photoAlt=" Fotografia Corporativa"
      >
        <p className="mb-2">
          Cada vez mais a presença nas redes sociais é importante para vender o
          seu produto ou serviço.
        </p>
        <p className="mb-2">
          Documentar o dia a dia da sua empresa, as etapas de criação do seu
          produto até o resultado final dará a visibilidade que precisa para
          estar à frente nas vendas.
        </p>
      </PortfolioShow>
    </>
  )
}